module.exports = __webpack_public_path__ + "assets/img/solutions6.35a178ff.png";